import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={
    {name: '', name_vi: '', order: 0}
} images={
    {thumbnail: ''}
} selections={
    {category_id: 'inner-sound-all-category'}
} editors={
    {summary: '', summary_vi: ''}
} checkboxes={
    {is_show_for_bought_book: false}
}/>

const InnerSoundFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="name" alwaysOn/>
    </Filter>
);

export const InnerSoundList = props => (
    <List {...props} filters={<InnerSoundFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="name_vi"/>
            <TextField source="order"/>
            <TextField source="category_name"/>
            <EditButton basePath="/inner-sound"/>
        </Datagrid>
    </List>
);

export const InnerSoundEdit = props => (
    <Edit title='Update' {...props}>
        {form}
    </Edit>
);

export const InnerSoundCreate = props => (
    <Create title="Create" {...props}>
        {form}
    </Create>
);
